import { useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';


// Hook permissões
const usePermission = (permissionId, isPublic = false) => {
    const navigate = useNavigate();
    const { permissions } = useAppContext();
    useEffect(() => {
        if (!isPublic) {
            if (!permissions.includes(permissionId)) {
                navigate("/403");
            }
        }
    }, [permissions, permissionId, navigate]);
};

export default usePermission;
